<div class="login-container">
  <alert></alert>
  <div class="content-container">

    <div class="card-login">

      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <img class="avux-logo" src="/assets/img/logo/avux-lg-green.svg" alt="Avux logo">
            <language-select></language-select>
        </div>
        <div class="d-flex align-items-center justify-content-between mt-3">
            <span class="logon-text">{{'login.login' | translate}}</span>
        </div>

      </div>

      <div class="card-body">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <b><label kupari-label for="username" [class]="'control-label mb-1'" [text]="'messaging.email_address'"></label></b>
            <kupari-input [icon]="'fa-light fa-envelope'" formControlName="username" [placeholder]="'login.username_placeholder' | translate" [class]="'form-control'"></kupari-input>
          </div>

          <div class="form-group">
            <b><label kupari-label for="password" [class]="'control-label mb-1'" [text]="'user.passphrase'"></label></b>
            <kupari-input [icon]="'fa-light fa-lock'" formControlName="password" [placeholder]="'********'" [type]="'password'" [class]="'form-control'">
            </kupari-input>
          </div>

          <!-- <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="remember-me" formControlName="rememberMe">
          <label class="custom-control-label" for="remember-me">Remember me</label>
        </div>
      </div> -->


        <div class="text-right">
          <!--<a routerLink="/register" class="d-block small mt-3">Register</a>-->
          <a [routerLink]="['/forgot-password']" class="d-block small my-2 bold">
              <b>{{'login.forgot_password' | translate}}</b>
            </a>
        </div>
          <div class="form-group justify-content-center">
            <kupari-button [type]="'submit'" [class]="'btn btn-primary w-100 bolder-button shadow'" [text]="'login.login'"></kupari-button>
          </div>
        </form>
      </div>
      <div class="card-footer">
        <app-login-footer></app-login-footer>
      </div>
    </div>

  </div>
  <div class="brand-image-container">
  </div>



</div>
